module.exports = __webpack_public_path__ + "img/video_cover.8151b768.jpg";